import React, { FC } from 'react';

import { SFHeaderFooterCategoryFooterViewModel } from '@api/index';

import { Category, CategoryGrid, Heading, Wrapper } from './styled';
import SubProduct from './subProducts';

export interface IFooterProducts {
  categoryFooterData: SFHeaderFooterCategoryFooterViewModel['categoryFooter'];
}

const FooterProducts: FC<IFooterProducts> = ({ categoryFooterData }) => {
  if (
    !categoryFooterData ||
    (Array.isArray(categoryFooterData?.categoryItems) &&
      categoryFooterData?.categoryItems?.length === 0)
  ) {
    return null;
  }

  return (
    <Wrapper>
      <CategoryGrid>
        {categoryFooterData?.categoryItems?.map((item, i) => (
          <Category key={i}>
            <Heading>{item.name}</Heading>
            {item.children && <SubProduct items={item.children} />}
          </Category>
        ))}
      </CategoryGrid>
    </Wrapper>
  );
};
export default FooterProducts;
